export const toUTagBool = (value: object) => [(!!value).toString()];
